import {
  FETCH_QUEUE_MESSAGE_START,
  FETCH_QUEUE_MESSAGE_SUCCESS,
  FETCH_QUEUE_MESSAGE_ERROR,
  FETCH_QUEUE_MESSAGES_START,
  FETCH_QUEUE_MESSAGES_SUCCESS,
  FETCH_QUEUE_MESSAGES_ERROR,
  SHOW_MESSAGE,
  QUEUE_MESSAGES_LOADING,
  DELETE_QUEUE_MESSAGE_START,
  DELETE_QUEUE_MESSAGE_SUCCESS,
  DELETE_QUEUE_MESSAGE_ERROR,
} from '../../constants/ActionTypes';
import { logsAxios } from '../../util/Api';

// eslint-disable-next-line import/prefer-default-export
export const getQueueMessages = (params) => (dispatch) => {
  dispatch({ type: FETCH_QUEUE_MESSAGES_START });
  logsAxios.get(`queue-messages/${params ? `?${params}` : ''}`).then(({ data, headers }) => {
    dispatch({
      type: FETCH_QUEUE_MESSAGES_SUCCESS,
      payload: data,
      currentPage: Number(headers['content-range'].split('-')[0]),
      totalRecords: Number(headers['content-range'].split('/')[1]),
    });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: FETCH_QUEUE_MESSAGES_ERROR, payload: error.response.data.message });
    } else if (error.response && error.response.error) {
      dispatch({ type: FETCH_QUEUE_MESSAGES_ERROR, payload: error.response.error });
    } else if (error && error.error) {
      dispatch({ type: FETCH_QUEUE_MESSAGES_ERROR, payload: error.error });
    } else if (error && error.message) {
      dispatch({ type: FETCH_QUEUE_MESSAGES_ERROR, payload: error.message });
    }
    dispatch({ type: SHOW_MESSAGE, payload: error?.response?.data?.message || error.message });
    console.error('Error: ', error.message);
  });
};

export const getQueueMessageById = (id) => (dispatch) => {
  dispatch({ type: FETCH_QUEUE_MESSAGE_START });
  logsAxios.get(`/queue-messages/${id}`).then(({ data }) => {
    dispatch({ type: FETCH_QUEUE_MESSAGE_SUCCESS, payload: data });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: FETCH_QUEUE_MESSAGE_ERROR, payload: error.response.data.message });
    }
    console.error('Error: ', error.message);
  });
};

export const requeueQueueMessageById = (id) => (dispatch) => {
  dispatch({ type: QUEUE_MESSAGES_LOADING, payload: true });
  logsAxios.post(`/queue-messages/requeue/${id}`, {}).then(({ data }) => {
    dispatch({ type: SHOW_MESSAGE, payload: data });
    dispatch({ type: QUEUE_MESSAGES_LOADING, payload: false });
  }).catch((error) => {
    dispatch({ type: QUEUE_MESSAGES_LOADING, payload: false });
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_MESSAGE, payload: error.response.data.message });
    }
    console.error('Error: ', error.message);
  });
};

export const deleteQueueMessageById = (id) => (dispatch) => {
  dispatch({ type: DELETE_QUEUE_MESSAGE_START, payload: true });
  logsAxios.delete(`/queue-messages/${id}`).then(({ data }) => {
    dispatch({ type: SHOW_MESSAGE, payload: data });
    dispatch({ type: DELETE_QUEUE_MESSAGE_SUCCESS, payload: id });
  }).catch((error) => {
    dispatch({
      type: DELETE_QUEUE_MESSAGE_ERROR,
      payload: error?.response?.data?.message || error.response.message || error.message,
    });

    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_MESSAGE, payload: error.response.data.message });
    }
    console.error('Error: ', error.message);
  });
};
